export default __webpack_public_path__ + "static/media/Aly Fadil 1.856a63bc.png";